export const ShowcaseHint = () => (
  <p className="mb-6 rounded-lg border border-[var(--color-border)] bg-[var(--color-surface-muted)] px-4 py-3 text-sm text-[var(--color-text-muted)]">
    Switch between light and dark theme using the avatar menu in the header.
  </p>
);
